import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { DiscountIcon, StarIcon } from '../../../assets/Icons';

interface FilterBadgesProps {
  filters: {
    bestsellers: boolean;
    promotions: boolean;
  };
  setFilters: React.Dispatch<
    React.SetStateAction<{
      bestsellers: boolean;
      promotions: boolean;
    }>
  >;
}

const FilterContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

const StyledChip = styled(Chip)<{ active?: boolean }>`
  background-color: ${props => (props.active ? '#1976d2' : '#f5f5f5')};
  color: ${props => (props.active ? '#ffffff' : '#666666')};
  border: 1px solid ${props => (props.active ? '#1976d2' : '#e0e0e0')};
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: ${props => (props.active ? '#1565c0' : '#eeeeee')};
    border-color: ${props => (props.active ? '#1565c0' : '#d0d0d0')};
  }

  .MuiChip-icon {
    color: ${props => (props.active ? '#ffffff' : '#666666')};
  }
`;

export const FilterBadges: React.FC<FilterBadgesProps> = ({ filters, setFilters }) => {
  const handleFilterToggle = (filterType: 'bestsellers' | 'promotions') => {
    setFilters(prev => ({
      ...prev,
      [filterType]: !prev[filterType]
    }));
  };

  return (
    <FilterContainer>
      <StyledChip
        active={filters.bestsellers}
        icon={<StarIcon className="w-4 h-4" />}
        label="Bestsellers"
        onClick={() => handleFilterToggle('bestsellers')}
        clickable
        size="medium"
      />
      <StyledChip
        active={filters.promotions}
        icon={<DiscountIcon className="w-4 h-4" />}
        label="Promotions"
        onClick={() => handleFilterToggle('promotions')}
        clickable
        size="medium"
      />
    </FilterContainer>
  );
};
